import api from "../../lib/api/api";
import {
  FETCH_ENROLLED_COURSES_FAILURE,
  FETCH_ENROLLED_COURSES_FAILURE_IDS,
  FETCH_ENROLLED_COURSES_REQUEST,
  FETCH_ENROLLED_COURSES_REQUEST_IDS,
  FETCH_ENROLLED_COURSES_SUCCESS,
  FETCH_ENROLLED_COURSES_SUCCESS_IDS,
} from "../Actions/types";

// Action to fetch enrolled courses for a student by studentId
export const fetchEnrolledCourses = () => async (dispatch) => {
  dispatch({ type: FETCH_ENROLLED_COURSES_REQUEST });

  try {
    const response = await api.get(`/enrollment/student/grouped`, {
      withCredentials: true,
    });

    if (typeof response.data === "string") {
      dispatch({
        type: FETCH_ENROLLED_COURSES_FAILURE,
        payload: response.data,
      });
    } else {
      dispatch({
        type: FETCH_ENROLLED_COURSES_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Error fetching enrolled courses!";
    dispatch({ type: FETCH_ENROLLED_COURSES_FAILURE, payload: errorMessage });
  }
};
export const fetchEnrolledCoursesIds = () => async (dispatch) => {
  dispatch({ type: FETCH_ENROLLED_COURSES_REQUEST_IDS });
  try {
    const response = await api.get(`/enrollment/student/ids`, {
      withCredentials: true,
    });
    // Check if the response is a message instead of data
    if (typeof response.data === "string") {
      dispatch({
        type: FETCH_ENROLLED_COURSES_FAILURE_IDS,
        payload: response.data,
      });
    } else {
      dispatch({
        type: FETCH_ENROLLED_COURSES_SUCCESS_IDS,
        payload: response.data,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Error fetching enrolled course IDs!";
    dispatch({
      type: FETCH_ENROLLED_COURSES_FAILURE_IDS,
      payload: errorMessage,
    });
  }
};
